"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const react_router_1 = require("react-router");
const immutable_1 = require("immutable");
const accounts_1 = require("companion-app-components/flux/accounts");
const selectors_1 = require("companion-app-components/flux/preferences/selectors");
const selectors_2 = require("data/accountNodes/selectors");
const selectors_3 = require("data/transactions/selectors");
const ErrorBoundary_1 = __importDefault(require("components/ErrorBoundary"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const Header_1 = __importDefault(require("./Header"));
const utils_1 = require("./utils");
const WeekDaysHeader_1 = __importDefault(require("./WeekDaysHeader"));
const DaysGrid_1 = __importDefault(require("./DaysGrid"));
const PrefModal_1 = __importDefault(require("./PrefModal"));
const useStyles = (0, mui_1.makeStyles)()((theme) => ({
    calendarCard: {
        width: '100%',
        height: 275,
        cursor: 'pointer',
        backgroundColor: theme.palette.background.paper,
        overflow: 'hidden',
        transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '&:focus': {
            outline: 'none',
            transform: 'translate(0px, -1px)',
        },
    },
    calendarContent: {
        margin: '10px 15px 10px 15px',
    },
}));
const CalendarCard = () => {
    const { classes } = useStyles();
    const navigate = (0, react_router_1.useNavigate)();
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const accountsByIdData = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getAccountsById);
    const accountsById = (0, react_1.useMemo)(() => accountsByIdData && accountsByIdData.filterNot((account) => (account.type === 'INVESTMENT')), [accountsByIdData]);
    const { accountsToShow } = datasetPreferences.calendarTransaction;
    // @ts-expect-error: Only a void function can be called with the 'new' keyword.
    const cachedAccountIds = (0, react_1.useMemo)(() => accountsToShow || new immutable_1.Set(), [accountsToShow]);
    // STATE
    const [curMonth, setCurMonth] = (0, react_1.useState)((0, utils_1.getCurrentMonthData)());
    const [daysTxsMap, setDaysTxsMap] = (0, react_1.useState)(null);
    const [showCalPrefs, setShowCalPrefs] = (0, react_1.useState)(false);
    const accountNodesById = (0, react_redux_1.useSelector)(selectors_2.getAccountNodesById);
    const loading = (0, react_redux_1.useSelector)(selectors_1.getIsLoading);
    const transactionsData = (0, react_redux_1.useSelector)((state) => {
        if (!cachedAccountIds || !(cachedAccountIds === null || cachedAccountIds === void 0 ? void 0 : cachedAccountIds.size))
            return (0, immutable_1.OrderedMap)();
        return (0, selectors_3.getTransactionsByFilter)(state, { accountIdsArray: cachedAccountIds });
    });
    const cachedTransactionsData = (0, react_1.useMemo)(() => transactionsData, [transactionsData]);
    const cachedCurMonth = (0, react_1.useMemo)(() => curMonth, [curMonth]);
    const cachedDaysTxsMap = (0, react_1.useMemo)(() => daysTxsMap, [daysTxsMap]);
    (0, react_1.useEffect)(() => {
        setDaysTxsMap((0, utils_1.reduceMonthTransactions)(cachedTransactionsData, curMonth));
    }, [cachedTransactionsData, curMonth]);
    (0, react_1.useEffect)(() => {
        if (!loading && ((accountsToShow === null || accountsToShow === void 0 ? void 0 : accountsToShow.size) === 0 || accountsToShow === null)) {
            setDatasetPreference({ calendarTransaction: { accountsToShow: accountsById.map((acc) => acc.id).toSet() } });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accountsById, accountsToShow]);
    const onCalendarDateChange = (0, react_1.useCallback)((newMonth) => {
        const currentMonthData = (0, utils_1.getCurrentMonthData)(newMonth.toFormat(utils_1.yearFormat), newMonth.toFormat(utils_1.monthFormat));
        setCurMonth(currentMonthData);
        setDaysTxsMap((0, utils_1.reduceMonthTransactions)(cachedTransactionsData, currentMonthData));
    }, [setCurMonth, setDaysTxsMap, cachedTransactionsData]);
    const onTransactionClick = (0, react_1.useCallback)((txn) => {
        // @ts-expect-error: 'accountNodesById' is of type 'unknown'.
        const node = accountNodesById.get(txn.accountId);
        navigate(`/transactions?displayNode=${node.id}&txnId=${txn.id}`, { replace: true });
    }, [accountNodesById, navigate]);
    const onPrefsOpen = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        setShowCalPrefs(true);
    }, [setShowCalPrefs]);
    const onPrefsClose = (0, react_1.useCallback)(() => setShowCalPrefs(false), [setShowCalPrefs]);
    return (<ErrorBoundary_1.default>
      {/* eslint-disable-next-line */}
      <div id="calendar-card" role="button" tabIndex={0} className={classes.calendarCard}>
        <div>
          <Header_1.default curMonth={curMonth} updateDateState={onCalendarDateChange} onPrefsOpen={onPrefsOpen}/>
        </div>
        <div className={classes.calendarContent}>
          <WeekDaysHeader_1.default days={utils_1.shortWeekDays}/>
          <DaysGrid_1.default curMonth={cachedCurMonth} daysTxsMap={cachedDaysTxsMap} onTransactionClick={onTransactionClick}/>
          {showCalPrefs && <PrefModal_1.default onClose={onPrefsClose}/>}
        </div>
      </div>
    </ErrorBoundary_1.default>);
};
exports.default = CalendarCard;
